// extracted by mini-css-extract-plugin
export var gif = "_gc-0";